import {useTranslation} from 'react-i18next';
import {Text} from '@treatwell/ui';
import styles from './Footer.module.css';
import {PageContainer} from '../../pages';
import {Marketplace} from '../Marketplace';

export const Footer = ({text}: {text: string}) => {
  return (
    <footer className={styles.root}>
      <PageContainer withPadding>
        <Text as="p" type="footnote">
          {text}
        </Text>
      </PageContainer>
    </footer>
  );
};

export const FooterContainer = () => {
  const {t} = useTranslation();
  const currentYear = new Date().getFullYear();
  const copyright = `© ${currentYear} ${t('copyright.text')}`;
  return (
    <Marketplace>
      <Footer text={copyright} />
    </Marketplace>
  );
};
